import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import {
  selectForwardAccumulatorScheduleData,
  selectForwardAccumulatorScheduleFieldValidation,
  selectForwardAccumulatorScheduleTable,
} from '@/store/forwardAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

const PaymentDate = ({ legId }: { legId: string }) => {
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const tileId = useForwardAccumulatorTileId();
  const checkForwardAccumulatorWithTradeCapture = useCheckForwardAccumulatorByTradeCapture();
  const paymentDate = useAppSelector(
    (state) => selectForwardAccumulatorScheduleTable(state, tileId, legId)?.paymentDate,
  );
  const isModified = useAppSelector(
    (state) =>
      selectForwardAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('PaymentDate') ??
      false,
  );
  const { validation } = useAppSelector((state) =>
    selectForwardAccumulatorScheduleFieldValidation(state, tileId, legId, 'paymentDateString'),
  );

  const handlePaymentDate = (value: string) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Schedule payment date changed', value ?? 'null');

    return checkForwardAccumulatorWithTradeCapture({
      schedule: { [legId]: { paymentDate: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '8rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext
          color={isModified ? 'info' : undefined}
          date={isDefined(paymentDate) ? paymentDate : undefined}
          onChange={handlePaymentDate}
          data-e2e="paymentDate"
          allTenors={[]}
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default PaymentDate;
